module.exports = __webpack_public_path__ + "static/media/vf-button-men-dress-shoes.48eb9c08.svg";